import React from 'react';
import { RailsTile } from '@sls-react/typings/services/rails/tile';
import Image from '@sls-react/components/Image';
import { useWindowSize } from 'react-use';

interface BasicTileProps {
  mobile?: boolean;
  onClick?: React.MouseEventHandler;
  tile: RailsTile;
}

export const BasicTile: React.FC<BasicTileProps> = ({
  mobile,
  onClick,
  tile,
}) => {
  const { width } = useWindowSize();
  const image =
    (mobile
      ? tile.versions?.find(v => v.platform === 'mobile')?.background_image_url
      : tile.versions?.find(v => v.platform === 'web')?.background_image_url) ||
    tile.background_image_url;

  return (
    <a href={tile.destination} onClick={onClick}>
      {image ? (
        <Image
          alt={tile.title}
          src={image}
          className="block object-cover w-full h-auto rounded cursor-pointer"
          useFastly={{
            width: width > 1280 ? 400 : 240,
          }}
        />
      ) : (
        <div />
      )}

      <div className="block pt-1 text-sm font-semibold text-center">
        {tile.title}
      </div>
    </a>
  );
};

export default BasicTile;
